import ApiUtil from '../utils/ApiUtil';
import {getRequest} from './api';

export const getDealsApi = (args, callback, dispatch) => {
  const endpoint = '/v2/deals/get',
    token = args.token,
    qs = `search=${args.search}&location=${args.location}&distance=${args.distance}&currentLocation=${args.currentLocation}&category=${args.category}&highlighted=${args.highlighted}&online=${args.online}&companyId=${args.companyId}&sortBy=${args.sortBy}&fromDate=${args.fromDate}&toDate=${args.toDate}&limit=${args.limit}&key=${args.key}`,
    headers = {'Cache-Control': 'no-cache, no-store, must-revalidate'};
    
  getRequest({endpoint, token, qs}, headers, (err, res) => {
    ApiUtil.handleReponse(err, res, callback, dispatch);
  });
};
